var _path, _path2, _path3, _g, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGiroDeCliente(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "512pt",
    viewBox: "0 0 512 512.0003",
    width: "512pt",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m251.109375 101.839844v395.160156h-184.871094v-268.679688c0-19.039062 10.511719-36.300781 27.410157-45.039062l49.421874-25.5625zm0 0",
    fill: "#1b6aa6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m251.109375 101.839844v395.160156h-108.039063v-339.28125zm0 0",
    fill: "#173755"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m158.070312 434.289062v62.710938h-30v-62.710938c0-8.289062 6.71875-15 15-15 8.289063 0 15 6.710938 15 15zm0 0",
    fill: "#fff49c"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#d9eeff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m173.671875 374.171875c0 8.277344-6.710937 15-15 15h-92.433594v-30h92.433594c8.289063 0 15 6.71875 15 15zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m173.671875 319.109375c0 8.28125-6.710937 15-15 15h-92.433594v-30h92.433594c8.289063 0 15 6.710937 15 15zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m173.671875 263.261719c0 8.277343-6.710937 15-15 15h-92.433594v-30h92.433594c8.289063 0 15 6.707031 15 15zm0 0"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m158.070312 434.289062v62.710938h-15v-77.710938c8.289063 0 15 6.710938 15 15zm0 0",
    fill: "#fee276"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m173.671875 374.171875c0 8.277344-6.710937 15-15 15h-15.601563v-30h15.601563c8.289063 0 15 6.71875 15 15zm0 0",
    fill: "#b0e3fc"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m173.671875 319.109375c0 8.28125-6.710937 15-15 15h-15.601563v-30h15.601563c8.289063 0 15 6.710937 15 15zm0 0",
    fill: "#b0e3fc"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m158.671875 278.261719h-15.601563v-30h15.601563c8.289063 0 15 6.707031 15 15 0 8.277343-6.710937 15-15 15zm0 0",
    fill: "#b0e3fc"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m445.96875 110.765625v386.234375h-224.859375v-478.65625zm0 0",
    fill: "#1b6aa6"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m445.96875 110.765625v386.234375h-112.429688v-432.445312zm0 0",
    fill: "#173755"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m318.539062 434.289062v62.710938h-30v-62.710938c0-8.289062 6.710938-15 15-15 8.28125 0 15 6.710938 15 15zm0 0",
    fill: "#fff49c"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m378.539062 434.289062v62.710938h-30v-62.710938c0-8.289062 6.710938-15 15-15 8.28125 0 15 6.710938 15 15zm0 0",
    fill: "#fee276"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "m303.304688 308.664062c8.285156 0 15-6.714843 15-15v-30.40625c0-8.285156-6.714844-15-15-15-8.285157 0-15 6.714844-15 15v30.40625c0 8.285157 6.714843 15 15 15zm0 0",
    fill: "#fff"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "m363.570312 308.664062c8.28125 0 15-6.714843 15-15v-30.40625c0-8.285156-6.71875-15-15-15-8.285156 0-15 6.714844-15 15v30.40625c0 8.285157 6.714844 15 15 15zm0 0",
    fill: "#d9eeff"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "m303.507812 389.164062c8.28125 0 15-6.714843 15-15v-30.40625c0-8.285156-6.71875-15-15-15-8.285156 0-15 6.714844-15 15v30.40625c0 8.285157 6.714844 15 15 15zm0 0",
    fill: "#fff"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "m363.769531 328.757812c-8.28125 0-15 6.714844-15 15v30.40625c0 8.285157 6.71875 15 15 15 8.285157 0 15-6.714843 15-15v-30.40625c0-8.285156-6.714843-15-15-15zm0 0",
    fill: "#d9eeff"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "m303.40625 228.433594c8.28125 0 15-6.714844 15-15v-30.40625c0-8.285156-6.71875-15-15-15-8.285156 0-15 6.714844-15 15v30.40625c0 8.285156 6.714844 15 15 15zm0 0",
    fill: "#fff"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "m363.671875 228.433594c8.28125 0 15-6.714844 15-15v-30.40625c0-8.285156-6.71875-15-15-15-8.285156 0-15 6.714844-15 15v30.40625c0 8.285156 6.714844 15 15 15zm0 0",
    fill: "#d9eeff"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "m481.082031 178.121094c-2.390625 5.789062-7.980469 9.300781-13.882812 9.300781-1.898438 0-3.828125-.363281-5.699219-1.132813l-127.960938-52.597656v-32.429687l139.371094 57.277343c7.660156 3.152344 11.320313 11.921876 8.171875 19.582032zm0 0",
    fill: "#368bb2"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "m461.5 134.230469-127.960938-52.601563v-32.429687l139.371094 57.28125c7.660156 3.148437 11.320313 11.910156 8.171875 19.578125-2.390625 5.792968-7.980469 9.300781-13.882812 9.300781-1.898438 0-3.828125-.359375-5.699219-1.128906zm0 0",
    fill: "#368bb2"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "m445.96875 110.765625v55.191406l-112.429688-46.222656-112.429687-46.210937v-55.179688zm0 0",
    fill: "#fff49c"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "m445.96875 110.765625v55.191406l-112.429688-46.222656v-55.179687zm0 0",
    fill: "#fee276"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "m481.082031 126.058594c-2.390625 5.792968-7.980469 9.300781-13.882812 9.300781-1.898438 0-3.828125-.359375-5.699219-1.128906l-15.53125-6.378907-112.429688-46.222656-112.429687-46.207031-15.929687-6.550781c-7.660157-3.152344-11.320313-11.910156-8.167969-19.570313 3.148437-7.660156 11.910156-11.320312 19.570312-8.171875l4.527344 1.863282 112.429687 46.207031 112.429688 46.210937 26.941406 11.070313c7.660156 3.148437 11.320313 11.910156 8.171875 19.578125zm0 0",
    fill: "#d9eeff"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "m481.082031 178.121094c-2.390625 5.789062-7.980469 9.300781-13.882812 9.300781-1.898438 0-3.828125-.363281-5.699219-1.132813l-15.53125-6.378906-112.429688-46.21875-112.429687-46.210937-15.929687-6.550781c-7.660157-3.140626-11.320313-11.910157-8.167969-19.570313 3.148437-7.660156 11.910156-11.320313 19.570312-8.167969l4.527344 1.859375 112.429687 46.210938 112.429688 46.207031 26.941406 11.070312c7.660156 3.152344 11.320313 11.921876 8.171875 19.582032zm0 0",
    fill: "#d9eeff"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "m512 497c0 8.28125-6.71875 15-15 15h-482c-8.28125 0-15-6.71875-15-15s6.71875-15 15-15h482c8.28125 0 15 6.71875 15 15zm0 0",
    fill: "#00db7e"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "m512 497c0 8.28125-6.71875 15-15 15h-241v-30h241c8.28125 0 15 6.71875 15 15zm0 0",
    fill: "#00a863"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "m481.082031 178.121094c-2.390625 5.789062-7.980469 9.300781-13.882812 9.300781-1.898438 0-3.828125-.363281-5.699219-1.132813l-127.960938-52.597656v-32.429687l139.371094 57.277343c7.660156 3.152344 11.320313 11.921876 8.171875 19.582032zm0 0",
    fill: "#b0e3fc"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "m461.5 134.230469-127.960938-52.601563v-32.429687l139.371094 57.28125c7.660156 3.148437 11.320313 11.910156 8.171875 19.578125-2.390625 5.792968-7.980469 9.300781-13.882812 9.300781-1.898438 0-3.828125-.359375-5.699219-1.128906zm0 0",
    fill: "#b0e3fc"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGiroDeCliente);
export default __webpack_public_path__ + "static/media/giro_de_cliente.3f43cc86299a9a3bbbbaf09fac502bab.svg";
export { ForwardRef as ReactComponent };